<script>
export default {
  props: {
    selectedPage: {
      default: 1,
      type: Number,
    },
    maxVisibleButtons: {
      type: Number,
      required: false,
      default: 7,
    },
    params: {
      default: '',
      type: String,
    },
    totalPages: {
      default: 0,
      type: Number,
    },
    perPage: {
      default: 1,
      type: Number,
    },
    infinityAttr: {
      default: undefined,
      type: String,
    },
    isLoading: {
      default: false,
      type: Boolean,
    },
    limit: {
      default: 8,
      type: Number,
    },
    type: {
      default: 'default',
      type: String,
    },
  },
  data() {
    return {
      currentPage: this.selectedPage,
      isMobile: false,
      disabled: false,
    }
  },
  computed: {
    totalPagesNum: function() {
      const element = []
      for (let index = 0; index < Number(this.totalPages) - 1; index++) {
        element.push(index + 1)
      }
      return element
    },
    isInFirstPage() {
      return this.currentPage === 1
    },
    isInLastPage() {
      return this.currentPage === this.totalPages
    },
    startPage() {
      // When on the first page
      if (this.currentPage === 1) {
        return 1
      }
      // When on the last page
      if (this.currentPage === this.totalPages) {
        return this.totalPages - this.maxVisibleButtons
      }

      if (this.totalPages - this.currentPage < 9) {
        // When in between
        return this.currentPage - 4
      } else if (this.currentPage < this.maxVisibleButtons) {
        return 1
      } else {
        // When in between
        return this.currentPage - 1
      }
    },
    pages() {
      const range = []
      for (
        let i = this.startPage;
        i <=
        Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
        i += 1
      ) {
        if (i > 0 && i < this.totalPages) {
          range.push({
            value: i,
            isDisabled: i === this.currentPage,
          })
        }
      }

      return range
    },
  },
  watch: {
    isHitBottom: function() {
      if (this.isHitBottom) {
        setTimeout(() => {
          this.PaginateHandler(this.currentPage + 1)
        }, 300)
      }
    },
  },
  mounted() {
    this.checkMobile()
    if (this.$route.query.page) {
      // console.log(this.$route.query.page)
      this.currentPage = this.$route.query.page
    }
  },
  methods: {
    PaginateHandler(to) {
      // console.log(to)
      this.$emit('clicked', to)
      // console.log(to)
      this.currentPage = to
      this.disabled = true
      setTimeout(() => {
        this.disabled = false
      }, 750)
    },
    checkMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
  },
}
</script>

<template>
  <div v-if="totalPages > 0">
    <!-- v-if="isMobile === false && type === 'default'" -->
    <b-pagination
      v-if="false"
      v-model="currentPage"
      :total-rows="totalPages"
      :per-page="perPage"
      :limit="isMobile ? limit / 2 + 2 : limit"
      last-number
      :hide-goto-end-buttons="true"
      :prev-text="isMobile ? '' : $t('Prev Page')"
      :next-text="isMobile ? '' : $t('Next Page')"
      :class="disabled ? 'disabled' : ''"
      @input="PaginateHandler(currentPage)"
    ></b-pagination>
    <div v-else-if="type === 'load-more'" class="d-flex justify-content-center">
      <b-button
        v-show="currentPage < totalPages && !isLoading"
        v-cloak
        variant="primary"
        class="px-5 py-2"
        @click.prevent="PaginateHandler(currentPage + 1)"
        >{{ $t('view_more') }}</b-button
      >
    </div>
    <div
      v-if="isMobile === true && type !== 'default'"
      class="mobilePagination d-flex justify-content-center"
    >
      <!-- <img
      v-show="currentPage < totalPages"
      src="@assets/icons/loading.gif"
      alt="loading"
      class="loadingIcon"
    /> -->
      <b-button
        v-show="currentPage < totalPages && !isLoading"
        v-cloak
        variant="primary"
        class="px-5 py-2"
        @click.prevent="PaginateHandler(currentPage + 1)"
        >{{ $t('view_more') }}</b-button
      >
    </div>
    <ul
      v-if="isMobile === false && type === 'default' && totalPages > 1"
      role="menubar"
      aria-disabled="false"
      aria-label="Pagination"
      class="pagination b-pagination"
    >
      <!---->
      <li role="presentation" class="page-item">
        <button
          v-if="selectedPage === 1 || selectedPage === 0"
          role="menuitem"
          tabindex="-1"
          aria-label="Go to next page"
          class="page-link bg-primary text-white px-4"
          style="background: rgba(0,0,0,.25) !important"
        >
          {{ $t('Prev Page') }}
        </button>
        <a
          v-else
          role="menuitem"
          tabindex="-1"
          aria-label="Go to previous page"
          class="page-link bg-primary text-white px-4"
          :href="
            `?page=` +
              (currentPage * 1 - 1 * 1) +
              `${params ? '&' + params : ''}`
          "
          @click.prevent.stop="PaginateHandler(currentPage * 1 - 1 * 1)"
          >{{ $t('Prev Page') }}
        </a>
      </li>
      <!---->

      <!-- <li
        v-if="currentPage >= maxVisibleButtons"
        role="separator"
        class="page-item disabled bv-d-xs-down-none"
      >
        <span class="page-link">…</span>
      </li> -->
      <li
        v-if="currentPage >= maxVisibleButtons"
        role="presentation"
        class="page-item"
        :class="selectedPage === 1 ? 'active' : ''"
      >
        <a
          :aria-posinset="1"
          :aria-setsize="1"
          tabindex="-1"
          class="page-link"
          :href="`?page=1${params ? '&' + params : ''}`"
          @click.prevent.stop="PaginateHandler(1)"
        >
          1
        </a>
      </li>

      <li
        v-if="currentPage >= maxVisibleButtons"
        role="separator"
        class="page-item disabled bv-d-xs-down-none"
      >
        <span class="page-link">…</span>
      </li>

      <li
        v-for="(paging, index) in pages"
        :key="index"
        role="presentation"
        class="page-item"
        :class="selectedPage === paging.value ? 'active' : ''"
      >
        <a
          :href="`?page=${paging.value}${params ? '&' + params : ''}`"
          tabindex="-1"
          class="page-link"
          @click.prevent.stop="PaginateHandler(paging.value)"
        >
          {{ paging.value }}
        </a>
      </li>

      <li
        v-if="currentPage <= totalPages - maxVisibleButtons"
        role="separator"
        class="page-item disabled bv-d-xs-down-none"
      >
        <span class="page-link">…</span>
      </li>

      <li
        role="presentation"
        class="page-item"
        :class="selectedPage === totalPages ? 'active' : ''"
      >
        <a
          :aria-posinset="totalPages"
          :aria-setsize="totalPages"
          tabindex="-1"
          class="page-link"
          :href="`?page=${totalPages}${params ? '&' + params : ''}`"
          @click.prevent.stop="PaginateHandler(totalPages)"
        >
          {{ totalPages }}
        </a>
      </li>

      <li role="presentation" class="page-item">
        <button
          v-if="selectedPage >= totalPages"
          role="menuitem"
          tabindex="-1"
          aria-label="Go to next page"
          class="page-link bg-primary text-white px-4"
          style="background: rgba(0,0,0,.25) !important"
        >
          {{ $t('Next Page') }}
        </button>
        <a
          v-else
          role="menuitem"
          tabindex="-1"
          aria-label="Go to next page"
          class="page-link bg-primary text-white px-4"
          :href="
            `?page=` +
              (currentPage * 1 + 1 * 1) +
              `${params ? '&' + params : ''}`
          "
          @click.prevent.stop="PaginateHandler(currentPage * 1 + 1 * 1)"
          >{{ $t('Next Page') }}
        </a>
      </li>
      <!---->
    </ul>
  </div>
</template>

<style lang="scss">
@import '@design';
.pagination {
  justify-content: space-between;
  li {
    &:first-child,
    &:last-child {
      span,
      button {
        padding: 1rem 1.5rem;
        color: $white !important;
        background-color: $primary !important;
        border-radius: $radius / 2;
      }
    }
    &:first-child {
      margin-right: 2.5rem;
    }
    &:last-child {
      margin-left: 2.5rem;
    }
    &.disabled {
      opacity: 0.75;
    }
    &[role='separator'] {
      span {
        background: none !important;
      }
    }
    &.active a,
    &.active span {
      background-color: $dark !important;
    }
    [class~='page-link'] {
      padding: 1rem 1.15rem;
      font-weight: $semi-bold;
      color: $dark;
      border: none;
      border-radius: $radius / 2;
    }
  }
  &.disabled {
    li {
      &:first-child,
      &:last-child {
        span,
        a {
          z-index: -1;
          pointer-events: none;
          cursor: wait !important;
        }
      }
    }
  }
}
@media only screen and (max-width: $mobile-sm) {
  .pagination {
    justify-content: space-between;
    li {
      &:first-child,
      &:last-child {
        position: relative;
        width: 1.75rem;
        span,
        button {
          padding: 0.75rem 1rem;
        }
      }
      &:first-child {
        margin-right: 1.5rem;
        span,
        button {
          &::before {
            position: absolute;
            top: 50%;
            left: 50%;
            z-index: 1024;
            display: inline-block;
            width: 16px;
            height: 16px;
            margin-left: 3px;
            content: '';
            background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDQwNy40MzYgNDA3LjQzNiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDA3LjQzNiA0MDcuNDM2OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8cG9seWdvbiBwb2ludHM9IjExMi44MTQsMCA5MS41NjYsMjEuMTc4IDI3My41MTIsMjAzLjcxOCA5MS41NjYsMzg2LjI1OCAxMTIuODE0LDQwNy40MzYgMzE1Ljg2OSwyMDMuNzE4ICIvPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPC9zdmc+DQo=')
              no-repeat 0 0;
            filter: invert(1);
            background-size: 100%;
            transform: translate(-70%, -50%) rotate(180deg);
          }
        }
      }
      &:last-child {
        margin-left: 1.5rem;
        span,
        button {
          &::before {
            position: absolute;
            top: 50%;
            left: 50%;
            z-index: 1024;
            display: inline-block;
            width: 16px;
            height: 16px;
            margin-left: 3px;
            content: '';
            background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDQwNy40MzYgNDA3LjQzNiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDA3LjQzNiA0MDcuNDM2OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8cG9seWdvbiBwb2ludHM9IjExMi44MTQsMCA5MS41NjYsMjEuMTc4IDI3My41MTIsMjAzLjcxOCA5MS41NjYsMzg2LjI1OCAxMTIuODE0LDQwNy40MzYgMzE1Ljg2OSwyMDMuNzE4ICIvPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPC9zdmc+DQo=')
              no-repeat 0 0;
            filter: invert(1);
            background-size: 100%;
            transform: translate(-70%, -50%);
          }
        }
      }
      [class~='page-link'] {
        display: flex;
        align-items: center;
        height: 100%;
        padding: 0.5rem 0.75rem;
      }
    }
  }
}
</style>
